import { useMemo } from 'react';
import { AnySchema } from 'yup';

export const useInitialValue = <T>(data: object | null, schema: AnySchema) => {
  return useMemo(() => schema.cast(data, { stripUnknown: true, assert: false }) as T, [data]);
};
